import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <MediaSection />
        <CardsSection />
        <FeaturesSection />
        <AboutSection />
        <UpdatesSection />
        <IndexSection />
        <FaqSection />
        <ContactSection />
        <RankingSection />
        <CommentsSection />
        <CarouselSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}